import isNull from 'lodash/isNull'
import uuidv5 from 'uuid/v5'
import { mapShallowValues } from 'Services/extraObject'
import toUpper from 'lodash/toUpper'

/**
 * @param {ApiRegionZipAddress} apiRegion
 * @returns {ApiRegionZipAddress}
 */
const fixZipcodeAddress = (apiRegion) => {
  const replaceNull = value => item => isNull(item) ? value : item

  const cleanRegion = mapShallowValues(apiRegion, replaceNull(''))

  return cleanRegion
}

/**
 * @param {string} zipcode
 * @returns {string}
 */
const fixZipcode = (zipcode) => {
  const firstHalf = zipcode.slice(0, 5)
  const secondHalf = zipcode.slice(5, 8)

  return zipcode.includes('-')
    ? zipcode
    : firstHalf + '-' + secondHalf
}

/**
 * @param {ApiRegionCity} data
 * @returns {Region}
 */
export const parseCity = (data) => {
  const city = {
    idCity: data.id,
    city: data.name,
  }

  const state = {
    idState: data.idState,
    state: toUpper(data.ufState),
  }

  return {
    id: uuidv5(`${data.name} - ${data.ufState}`, '182f1728-af0c-11e9-a2a3-2a2ae2dbcce4'),
    text: `${data.name} - ${toUpper(data.ufState)}`,
    slug: data.slug,
    ...city,
    ...state,
  }
}

/**
 * @param {ApiCompanyRegion} data
 * @returns {Region}
 */
export const parseCompanyRegion = (data) => {
  const city = {
    idCity: data.idCity,
    city: data.nameCity,
  }

  const state = {
    idState: data.idState,
    state: toUpper(data.ufState),
  }

  return {
    id: uuidv5(`${data.nameCity} - ${data.ufState}`, '182f1728-af0c-11e9-a2a3-2a2ae2dbcce4'),
    text: `${data.nameCity} - ${toUpper(data.ufState)}`,
    slug: data.slug,
    ...city,
    ...state,
  }
}

/**
 * @param {ApiRegionZipAddress} apiRegion
 * @returns {AddressZipcode}
 */
export const parseZipcodeRegion = (apiRegion) => {
  const region = fixZipcodeAddress(apiRegion)

  return {
    neighborhood: region.borough,
    zipcode: fixZipcode(region.zipCode),
    stateId: region.idState,
    cityId: region.idCity,
    street: region.address,
  }
}


export default {
  parseCity,
  parseCompanyRegion,
  parseZipcodeRegion,
}
